var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBolt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "26px",
    viewBox: "0 0 19 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Loco-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Forniture-/-Energia",
    transform: "translate(-7.000000, -4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Loco-icon",
    transform: "translate(16.500000, 18.000000) rotate(30.000000) translate(-16.500000, -18.000000) translate(7.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lighting-Bolt",
    transform: "translate(0.064029, 0.203645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.490889871,15.1144376 L7.40963178,1.25716319 C7.89124156,0.292566034 9.05657921,-0.0954233104 10.0124863,0.390564734 C10.6661692,0.722900428 11.0785432,1.398507 11.0785432,2.13712238 L11.0785432,9.45323686 C11.0785432,9.95701015 11.4832529,10.365399 11.9824876,10.365399 L15.8852097,10.365399 C16.9835262,10.365399 17.8738876,11.2638546 17.8738876,12.3721558 C17.8738876,12.7026192 17.7930125,13.0279682 17.6384451,13.3193075 L10.1619564,27.411512 C9.65102381,28.3745531 8.4631655,28.737294 7.50880051,28.2217167 C6.87159764,27.8774801 6.47383726,27.2073203 6.47383726,26.4779767 L6.47383726,19.5049808 C6.47383726,19.0012075 6.06912752,18.5928187 5.56989277,18.5928187 L2.61401022,18.5928187 C1.30102862,18.5928187 0.236646735,17.5187606 0.236646735,16.1938427",
    id: "path-2"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolt);
export default __webpack_public_path__ + "static/media/bolt.8f5c4859fdc58f41d6d17987ce541193.svg";
export { ForwardRef as ReactComponent };